import { all, fork } from "typed-redux-saga";
import { fileSaga } from "./file";
import { messageSaga } from "./message";

export default function* leadSaga(): Generator {
    yield* all([fork(fileSaga), fork(messageSaga)]);
}
